import React, { useMemo } from 'react';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { Link, useParams } from 'react-router-dom';
import { Icon, Loading } from 'js/components';
import { isArchived } from 'js/utils/team-utils';
import AssessmentItem from './AssessmentItem';

export default function TeamRubricAssessmentHistory({
  team = null,
  questionSets = [],
  assessmentInstances = [],
  assessmentScoreMaps = {},
  loading = false,
  loadError = false,
}) {
  const { workspaceId, teamId } = useParams();
  const sortedAssessmentInstances = useMemo(() => {
    return [...assessmentInstances].sort((a, b) => {
      return b.inserted_at - a.inserted_at;
    });
  }, [assessmentInstances]);

  if (loading) {
    return <Loading />;
  }

  if (loadError) {
    return (
      <div className="media text-muted mt-4 mb-4">
        <Icon
          icon={faTriangleExclamation}
          size="4x"
          className="mr-3"
          fixedWidth
        />
        <div className="media-body">
          <p>
            Unable to load rubric activity at this time. Please try again later.
          </p>
        </div>
      </div>
    );
  }

  if (sortedAssessmentInstances.length === 0) {
    return (
      <div className="media text-muted mt-4 mb-4">
        <Icon
          icon={['fal', 'spider-web']}
          size="4x"
          className="mr-3"
          fixedWidth
        />
        <div className="media-body">
          <p>
            This team hasn't run any assessments associated with this rubric
            yet.
          </p>
          <Link
            className="btn btn-primary"
            to={`/w/${workspaceId}/teams/${teamId}/assessments/new`}
            disabled={team ? isArchived(team) : false}
          >
            <Icon icon={['far', 'poll']} size="lg" className="btn-icon-left" />
            Run an assessment now
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      {sortedAssessmentInstances.map((assessment) => (
        <AssessmentItem
          key={String(assessment.assessment_id ?? assessment.id ?? '')}
          assessment={assessment}
          questionSets={questionSets}
          assessmentScoreMaps={assessmentScoreMaps}
        />
      ))}
    </div>
  );
}
